import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const TRIAL_URL = "https://pay.rev.cat/kaooarqpwiwxiwlj";
const ease = [0.22, 1, 0.36, 1];

export const TrialCTA = () => (
  <section
    id="try"
    className="relative z-10 mx-auto max-w-5xl px-6 py-24 md:py-28"
    data-testid="trial-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease }}
      className="relative overflow-hidden rounded-[2.5rem] border border-white/10 bg-white/[0.03] px-8 py-16 text-center backdrop-blur-2xl md:px-16 md:py-20"
    >
      <div className="absolute -top-24 left-1/3 h-64 w-64 rounded-full bg-[#7c3aed] blur-[120px] opacity-30" />
      <div className="absolute -bottom-24 right-10 h-64 w-64 rounded-full bg-[#ffb7b2] blur-[120px] opacity-25" />

      <span className="relative inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-white/70">
        One week on us
      </span>

      <h2 className="relative mt-8 font-display text-4xl font-thin leading-[1.08] tracking-tight text-white md:text-6xl">
        Try the app for{" "}
        <span className="italic text-white/80">one week free.</span>
      </h2>

      <p className="relative mx-auto mt-6 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
        Try it for yourself to feel a shift in your experience.
      </p>

      <a
        href={TRIAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative mt-10 inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-sm font-medium text-black transition-transform duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(255,255,255,0.35)]"
        data-testid="trial-cta-button"
      >
        Start your free week
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>

      <p className="relative mt-6 text-xs text-white/40">
        (please sign up with an email you currently have access to)
      </p>
    </motion.div>
  </section>
);
